import axios, { CancelToken } from 'apis';
import { sessionService } from 'redux-react-session';
import { getThunkActionCreator } from 'redux-thunk-routine';

import {
  getDriverDutyLogsRoutine,
  clearDriverDutyLogsRoutine
} from 'actions';

const attributes = [
  'id',
  "check_in_at",
  "check_out_at",
  { user: ['id', 'first_name', 'last_name'] }
]

export const getDriverDutyLogs = getThunkActionCreator(
  getDriverDutyLogsRoutine,
  async ({ offset = 0, query, limit = 25 }) => {
    getDriverDutyLogs.getDriverDutyLogsCancel && getDriverDutyLogs.getDriverDutyLogsCancel();
    const { token: access_token } = await sessionService.loadSession();
    const response = await axios.get('/user/driver_duty_logs', {
      params: { access_token, limit: limit, offset, ...(!!query && { query }), attributes: attributes },
      cancelToken: new CancelToken(function executor(cancel) { getDriverDutyLogs.getDriverDutyLogsCancel = cancel } )
    });
    return response.data;
});

export const clearDriverDutyLogs = getThunkActionCreator(clearDriverDutyLogsRoutine, async () => {})